import React from 'react'

export const nevadaSetupVars = {
  siteId: 'nevada',
  topScreenshotUrl: '/images/nevada/marketing/images/Mockup@2x.png',
  pathPrefix: '/nv',
  menuHeader: "Discover Nevada's Solution for:",
  appUrl: 'https://nv.headed2.com',
  logoImg: '/images/assets/nevada/horizontal/dark.svg',
  headerTitle: `The Nevada CareerExplorer is a system designed for Nevada`,
  headerTitleDescription: (
    <div>
      <p>
        With information and reporting designed to support career readiness for Nevada's
        in-demand careers.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      Trusted by the <b>Nevada State Library and Public Records</b> to help{' '}
      <b>increase career readiness</b> for students across the country.
    </span>
  ),
  sponsorImg: `/images/nevada/marketing/images/Nevada_State_Library_and_Public_Records_Sponsored@2x.jpg`,
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-NV@2x.png',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=1sBZEcTnCgwN2p2LsbrlN4U8vwlG5z-GJ`,
  otherSites: [
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
